<template>
  <div class="views-templates">
    <Loading :isActive="loading"></Loading>
    <Edit :arquivo="currentItem" :update="update" />

    <!-- Search bar -->
    <div class="search-bar">
      <div class="search-input-wrapper">
        <fa-icon icon="search" class="search-icon" />
        <input
          type="text"
          class="form-control search-input"
          v-model="search"
          placeholder="Buscar template por nome ou caminho..."
        />
        <button
          v-if="search"
          class="search-clear"
          @click="search = ''"
        >
          <fa-icon icon="times" />
        </button>
      </div>
      <div class="search-stats" v-if="search">
        {{ totalFilteredFiles }} de {{ totalFiles }} templates
      </div>
    </div>

    <!-- Empty state -->
    <div class="empty-state" v-if="search && filteredArquivos.length === 0">
      <fa-icon icon="search" class="empty-state-icon" />
      <p class="empty-state-text">Nenhum template encontrado para "{{ search }}"</p>
      <button class="btn btn-outline-primary btn-sm" @click="search = ''">Limpar busca</button>
    </div>

    <!-- Template groups -->
    <div
      v-for="grupo in filteredArquivos"
      :key="grupo.nome_exibicao"
      class="template-group"
    >
      <div class="group-header" @click="toggleGroup(grupo.nome_exibicao)">
        <div class="group-header-left">
          <fa-icon
            :icon="expandedGroups[grupo.nome_exibicao] === false ? 'chevron-right' : 'chevron-down'"
            class="group-chevron"
          />
          <span class="group-title">{{ grupo.nome_exibicao }}</span>
        </div>
        <span class="group-badge">{{ grupo.arquivos.length }}</span>
      </div>

      <div class="group-body" v-show="expandedGroups[grupo.nome_exibicao] !== false">
        <div
          v-for="arquivo in grupo.arquivos"
          :key="arquivo.caminho"
          class="template-item"
        >
          <div class="template-info">
            <div class="template-name">
              {{ arquivo.nome_exibicao }}
              <span class="badge-customizado" v-if="arquivo.editado">
                Customizado
              </span>
            </div>
            <div class="template-path">{{ arquivo.caminho }}</div>
          </div>
          <div class="template-actions">
            <button
              class="action-btn action-btn--danger"
              @click="deleteArquivo(arquivo)"
              v-if="arquivo.editado"
              title="Desfazer customização"
            >
              <fa-icon icon="trash-alt" />
            </button>
            <button
              class="action-btn"
              @click="openPreview(arquivo)"
              title="Pré-visualizar"
            >
              <fa-icon icon="eye" />
            </button>
            <button
              class="action-btn action-btn--primary"
              @click="openEdit(arquivo)"
              title="Editar"
            >
              <fa-icon icon="pencil-alt" />
            </button>
            <LogAlteracaoDados
              tabela="/var/www/resources/custom_views"
              :chave="arquivo.caminho"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, put, del, open } from "../../helpers/apiRequest";
import Edit from "./Edit";
import clone from "just-clone";

export default {
  name: "ViewsTemplates",
  components: {
    Edit,
  },
  data() {
    return {
      loading: false,
      arquivos: [],
      currentItem: {},
      search: "",
      expandedGroups: {},
    };
  },
  computed: {
    filteredArquivos() {
      if (!this.search) return this.arquivos;

      const term = this.search.toLowerCase().trim();
      return this.arquivos
        .map((grupo) => {
          const filtered = grupo.arquivos.filter(
            (arquivo) =>
              arquivo.nome_exibicao.toLowerCase().includes(term) ||
              arquivo.caminho.toLowerCase().includes(term)
          );
          if (filtered.length === 0) return null;
          return { ...grupo, arquivos: filtered };
        })
        .filter(Boolean);
    },
    totalFiles() {
      return this.arquivos.reduce((sum, g) => sum + g.arquivos.length, 0);
    },
    totalFilteredFiles() {
      return this.filteredArquivos.reduce((sum, g) => sum + g.arquivos.length, 0);
    },
  },
  methods: {
    toggleGroup(nome) {
      this.$set(
        this.expandedGroups,
        nome,
        this.expandedGroups[nome] === false ? true : false
      );
    },
    loadArquivos() {
      get(`/admin/views-templates`)
        .then((json) => {
          this.arquivos = json;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openEdit(arquivo) {
      get(`/admin/views-templates/conteudo?caminho=${arquivo.caminho}`)
        .then((conteudo) => {
          this.currentItem = clone(arquivo);
          this.currentItem.conteudo = conteudo.conteudo;
          this.$modal.show("templateEdit");
          this.loading = false;
        })
        .catch((err) => {
          this.$swal({
            title: "Falha ao carregar conteúdo",
            text: err.message,
            icon: "error",
          });
        })
        .finally(() => (this.loading = false));
    },
    openPreview(arquivo) {
      const url = `/admin/views-templates/preview?caminho=${arquivo.caminho}`;
      open({ url, newTab: true });
    },
    update() {
      this.loading = true;
      put(`/admin/views-templates`, this.currentItem)
        .then((json) => {
          this.$modal.hide("templateEdit");
          this.loadArquivos();
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        })
        .finally(() => (this.loading = false));
    },
    deleteArquivo(arquivo) {
      this.$swal({
        title: "Descartar alterações ?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
      }).then((res) => {
        if (res.isConfirmed) {
          this.confirmDelete(arquivo);
        }
      });
    },
    confirmDelete(arquivo) {
      this.loading = true;
      del(`/admin/views-templates`, arquivo)
        .then((json) => {
          this.loadArquivos();
          this.$swal({
            title: "Descartado com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((err) => {
          this.$swal({
            title: "Falha ao descartar conteúdo",
            text: err.message,
            icon: "error",
          });
        })
        .finally(() => (this.loading = false));
    },
  },
  beforeMount() {
    this.loading = true;
    this.loadArquivos();
  },
};
</script>

<style scoped>
.views-templates {
}

/* Search */
.search-bar {
  margin-bottom: 20px;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 14px;
  color: #9ca3af;
  font-size: 14px;
  pointer-events: none;
}

.search-input {
  padding-left: 40px;
  padding-right: 40px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: #fff;
}

.search-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  outline: none;
}

.search-input::placeholder {
  color: #9ca3af;
}

.search-clear {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  font-size: 14px;
}

.search-clear:hover {
  color: #6b7280;
}

.search-stats {
  margin-top: 8px;
  font-size: 12px;
  color: #9ca3af;
  padding-left: 4px;
}

/* Empty state */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #9ca3af;
}

.empty-state-icon {
  font-size: 32px;
  margin-bottom: 16px;
  opacity: 0.4;
}

.empty-state-text {
  font-size: 14px;
  margin-bottom: 16px;
}

/* Groups */
.template-group {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 12px;
  overflow: hidden;
}

.group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.15s;
}

.group-header:hover {
  background-color: #f9fafb;
}

.group-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.group-chevron {
  font-size: 11px;
  color: #9ca3af;
  width: 12px;
}

.group-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.group-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  background-color: #f3f4f6;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
}

/* Template items */
.group-body {
  border-top: 1px solid #f3f4f6;
}

.template-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  transition: background-color 0.15s;
}

.template-item:not(:last-child) {
  border-bottom: 1px solid #f9fafb;
}

.template-item:hover {
  background-color: #fafbfc;
}

.template-info {
  flex: 1;
  min-width: 0;
}

.template-name {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}

.template-path {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
}

.badge-customizado {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

/* Action buttons */
.template-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 16px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 12px;
}

.action-btn:hover {
  background-color: #f3f4f6;
  color: #374151;
  border-color: #d1d5db;
}

.action-btn--primary {
  color: #3b82f6;
  border-color: #bfdbfe;
}

.action-btn--primary:hover {
  background-color: #eff6ff;
  color: #2563eb;
  border-color: #93c5fd;
}

.action-btn--danger {
  color: #ef4444;
  border-color: #fecaca;
}

.action-btn--danger:hover {
  background-color: #fef2f2;
  color: #dc2626;
  border-color: #f87171;
}
</style>
